import T from '../types';
import superagent from '@ott/superagent';
import { lang } from '@ott/l10n';
import { prepareSuggestResult } from '../adapters/suggestAdapter';

const RETRY_TIMEOUT = 1000;
const RETRY_COUNT = 9999;

const cache = {};

const activeRequests = {};
const retries = {};
const timeouts = {};

function createRequest(slug, query, text, dispatch) {
  activeRequests[slug] = superagent.get('/_avia/suggest/bestMatch2').query(query).withCredentials();

  activeRequests[slug]
    .then((res) => {
      const { body: response } = res;

      const items = prepareSuggestResult(response);

      cache[text] = items;

      dispatch({
        type: T.SUGGEST_SUCCESS,
        slug,
        query: text,
        items,
      });

      delete activeRequests[slug];
      retries[slug] = 0;
    })
    .catch((err) => {
      if (!retries.hasOwnProperty(slug)) {
        retries[slug] = 0;
      }

      if (retries[slug] < RETRY_COUNT) {
        retries[slug]++;
        timeouts[slug] = setTimeout(
          () => createRequest(slug, query, text, dispatch),
          RETRY_TIMEOUT
        );
      } else {
        console.error(err);
        dispatch({
          type: T.SUGGEST_FAIL,
          slug,
          query: text,
        });
      }
    });
}

export default function suggestDest(text = '', slug, additionalParams) {
  return async function (dispatch) {
    const cleanText = text.trim().toLowerCase();
    const initialText =
      additionalParams && additionalParams.from
        ? `BEST_MATCH_${additionalParams.from.code}`
        : 'BEST_MATCH';

    if (cleanText.length < 2 && cache.hasOwnProperty(initialText)) {
      dispatch({
        type: T.SUGGEST_SUCCESS,
        slug,
        query: text,
        items: cache[initialText],
      });

      return;
    }

    if (cache.hasOwnProperty(cleanText) && cleanText.length > 2) {
      dispatch({
        type: T.SUGGEST_SUCCESS,
        slug,
        query: text,
        items: cache[cleanText],
      });

      return;
    }

    dispatch({
      type: T.SUGGEST,
      slug,
      query: cleanText,
    });

    const activeRequest = activeRequests[slug];

    if (activeRequest) {
      activeRequest.abort();
    }

    retries[slug] = 0;

    clearTimeout(timeouts[slug]);

    const langWithoutLocale = lang.substring(0, 2);

    let query = {
      search: text,
      lang: langWithoutLocale,
      string: true,
      references: true,
    };

    if (cleanText.length < 2) {
      const { from } = additionalParams;

      query = {
        ...query,
        search: 'BEST_MATCH',
        locale: lang,
      };

      if (from) {
        query.from = from.code;
      }

      // eslint-disable-next-line no-param-reassign
      text = initialText;
    }

    createRequest(slug, query, text, dispatch);
  };
}
